module.exports = __webpack_public_path__ + "img/Aniversario.5ceb745f.webp";